<script>
import { useValidation } from '@/hooks/useValidation'
import { useMessage } from '@/hooks/useMessage'
import { asynchronousReturn } from '@/@core/utils'
import { reactive, ref, onMounted } from '@vue/composition-api'
import Dialog from '@/components/Dialog.vue'
import { getAppRoleList, addConfig, updateConfig } from '../service'

export default {
  name: 'AddDialog',
  components: { Dialog },
  props: {
    title: {
      type: String,
      default: '提示',
    },
    rowItem: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const show = ref(true)
    const formRef = ref()
    const roleList = ref([])
    const isAll = ref(false)
    const isShow = ref(false)
    const { message } = useMessage()
    const { required } = useValidation()
    const formData = reactive({
      name: undefined,
      appId: undefined,
      roleIds: [],
      url: undefined,
    })
    const close = () => {
      show.value = false
      setTimeout(() => {
        emit('close')
      }, 300)
    }

    const changeAppId = async val => {
      if (!val) return
      formData.roleIds = []
      try {
        const { data } = await getAppRoleList({ appId: val })
        isAll.value = false
        if (!data.data.length) {
          message.warning('该系统下暂无角色')
          isShow.value = false
          roleList.value = [{ text: '全部', value: 'ALL' }]

          if (!props.rowItem.id) {
            isAll.value = true
            formData.roleIds = ['ALL']
          }
        } else {
          isShow.value = true
          roleList.value = [...data.data.map(item => ({ ...item, text: item.name, value: item.id }))]

          if (!props.rowItem.id) {
            isAll.value = true
            formData.roleIds = roleList.value.map(item => item.value)
          }
        }
      } catch (error) {
        return error
      }
    }

    function changeRoles(val) {
      if (val && val.length < roleList.value.length && isAll.value) {
        console.log(1)
        isAll.value = false
      }

      if (val && val.length === roleList.value.length && !isAll.value) {
        console.log(2)
        isAll.value = true
      }
    }

    function changeAll(val) {
      if (val) {
        formData.roleIds = roleList.value.map(item => item.value)
      } else {
        formData.roleIds = []
      }
    }
    const submit = () => {
      asynchronousReturn(formRef.value.validate).then(() => {
        const params = {
          ...formData,
          roleIds: isAll.value ? 'ALL' : formData.roleIds.join(','),
          id: props.rowItem.id,
        }

        if (props.rowItem.id) {
          updateConfig(params).then(({ data }) => {
            if (data.status === 200) {
              message.success('编辑成功')
              emit('refresh')
              close()
            }
          }).catch(error => message.error(error.response.data.message))
        } else {
          addConfig(params).then(({ data }) => {
            if (data.status === 200) {
              message.success('添加成功')
              emit('refresh')
              close()
            }
          }).catch(error => message.error(error.response.data.message))
        }
      }).catch(() => message.warning('请把带*填写完整'))
    }

    onMounted(async () => {
      if (props.rowItem.id) {
        Object.assign(formData, props.rowItem)
        await changeAppId(props.rowItem.appId)

        if (props.rowItem.roleIds === 'ALL') {
          formData.roleIds = roleList.value.map(item => item.value)
          isAll.value = true
        } else {
          formData.roleIds = props.rowItem?.roleIds.split(',').map(item => (item === 'ALL' ? 'ALL' : Number(item)))
        }
      }
    })

    return { show, formRef, close, submit, formData, changeAppId, required, roleList, changeRoles, isAll, changeAll, isShow }
  },
}
</script>
<template>
  <Dialog
    v-model="show"
    :title="title"
    show-footer
    width="550px"
    confirm-btn-text="保存"
    @cancel="close"
    @confirm="submit"
  >
    <vl-form ref="formRef" label-width="100" layout="left">
      <vl-form-item label="看板名称" required>
        <v-text-field v-model="formData.name" outlined dense maxlength="20" :rules="[required]" placeholder="请定义数据看板名称"></v-text-field>
      </vl-form-item>
      <vl-form-item label="所属系统" required>
        <v-autocomplete v-model="formData.appId" outlined dense :items="list.filter(item => item.value)" :rules="[required]" placeholder="请选择" @change="changeAppId"></v-autocomplete>
      </vl-form-item>
      <vl-form-item label="分配角色" required>
        <v-autocomplete v-model="formData.roleIds" outlined dense multiple :rules="[required]" :items="roleList" clearable placeholder="请选择" @change="changeRoles">
          <template #selection="{ item, index }">
            <div v-if="isAll" class="d-flex">
              <v-chip v-if="index < 1" :key="index" label small>
                <div>全部</div>
              </v-chip>
            </div>
            <div v-else style="display: flex">
              <v-chip
                v-if="index < 1"
                :key="index"
                label
                small
              >
                <div
                  class="sle"
                  style="max-width: 200px; height: 20px"
                >
                  {{ item.text }}
                </div>
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption fs16"
              >
                +{{ formData.roleIds.length - 1 }}
              </span>
            </div>
          </template>
          <template #prepend-item>
            <div v-if="isShow" class="prepend" :class="{active:isAll}">
              <v-checkbox v-model="isAll" label="全部" :false-value="false" :true-value="true" :class="{active:isAll}" @change="changeAll"></v-checkbox>
            </div>
          </template>
        </v-autocomplete>
      </vl-form-item>
      <vl-form-item label="访问url" required>
        <v-textarea v-model="formData.url" outlined dense no-resize height="180px" counter="500" maxlength="500" :rules="[required]" placeholder="请输入url"></v-textarea>
      </vl-form-item>
    </vl-form>

    <div class="remark mt10">
      注：选择角色前请选择所属系统
    </div>
  </Dialog>
</template>
<style scoped lang='scss'>

::v-deep .v-input {
   .v-input__control {
    .v-input__slot {
      height: 32px;
      margin: 0;

      .v-input__append-inner {
        margin-top: 0 !important;
        height: 100%;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .v-text-field__details {
      transform: translateY(5px);
      margin-bottom: 0;
      min-height: 0;
      .v-messages {
        min-height: min-content;
      }
    }
  }
}

.prepend{
  padding: 0 16px;
  background-color: #ffffff;
  min-height: 2rem;
  height: 2rem;
  &.active{
    caret-color: var(--v-primary-base) !important;
    background: rgba($color: #9155FD, $alpha: 0.13) !important;

    ::v-deep .v-label{
      color: var(--v-primary-base) !important;
    }
  }
}

::v-deep .v-label{
  font-size: 0.875rem !important;
  color: rgba(19, 17, 32, 0.87) !important;
  font-weight: 500;
  line-height: 1rem;
  &.active{
    color: var(--v-primary-base) !important;
  }
}
::v-deep .v-application--is-ltr .v-input--selection-controls__input{
  margin-right: 12px;
  margin-top: 0;
  padding-top: 0;
}
::v-deep .v-input--selection-controls{
  margin-top: 0;
  padding-top: 0;
}
::v-deep .v-list{
  padding: 0 0 8px 0;
}
</style>
